import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const api = {
  // Consultas
  getConsultas: (estado) =>
    axios.get(`${API_URL}/api/consultas${estado ? `?estado=${estado}` : ""}`),

  getConsulta: (id) =>
    axios.get(`${API_URL}/api/consultas/${id}`),

  createConsulta: (data) =>
    axios.post(`${API_URL}/api/consultas`, data),

  updateConsulta: (id, data) =>
    axios.put(`${API_URL}/api/consultas/${id}`, data),

  deleteConsulta: (id) =>
    axios.delete(`${API_URL}/api/consultas/${id}`),

  convertirConsulta: (id) =>
    axios.post(`${API_URL}/api/consultas/${id}/convertir`),
  addConsultaContacto: (id, data) =>
    axios.post(`${API_URL}/api/consultas/${id}/contactos`, data),
  deleteConsultaContacto: (consultaId, logId) =>
    axios.delete(`${API_URL}/api/consultas/${consultaId}/contactos/${logId}`),

  getConsultasStats: () =>
    axios.get(`${API_URL}/api/consultas/stats`),

  // Clientes
  getClientes: () =>
    axios.get(`${API_URL}/api/clientes`),

  getCliente: (id) =>
    axios.get(`${API_URL}/api/clientes/${id}`),

  updateCliente: (id, data) =>
    axios.put(`${API_URL}/api/clientes/${id}`, data),

  deleteCliente: (id) =>
    axios.delete(`${API_URL}/api/clientes/${id}`),

  desconvertirCliente: (id) =>
    axios.post(`${API_URL}/api/clientes/${id}/desconvertir`),

  getClientesStats: () =>
    axios.get(`${API_URL}/api/clientes/stats`),

  // Tasks
  getTasks: (entidad_tipo, entidad_id) =>
    axios.get(`${API_URL}/api/tasks?entidad_tipo=${entidad_tipo}&entidad_id=${entidad_id}`),

  createTask: (data) =>
    axios.post(`${API_URL}/api/tasks`, data),

  updateTask: (id, data) =>
    axios.put(`${API_URL}/api/tasks/${id}`, data),

  deleteTask: (id) =>
    axios.delete(`${API_URL}/api/tasks/${id}`),

  getPendingTasks: () =>
    axios.get(`${API_URL}/api/tasks/pending`),

  // Dashboard
  getDashboardStats: () =>
    axios.get(`${API_URL}/api/dashboard/stats`),

  // Search
  search: (query) =>
    axios.get(`${API_URL}/api/search?q=${encodeURIComponent(query)}`),

  // Calendar
  getCalendarToken: () =>
    axios.get(`${API_URL}/api/calendar/token`),

  generateCalendarToken: () =>
    axios.post(`${API_URL}/api/calendar/token`),

  // Configuration
  getEmpresaConfig: () =>
    axios.get(`${API_URL}/api/config/empresa`),

  updateEmpresaConfig: (data) =>
    axios.put(`${API_URL}/api/config/empresa`, data),

  limpiarFechasContacto: () =>
    axios.post(`${API_URL}/api/config/limpiar-fechas-contacto`),

  limpiarTareasPendientes: () =>
    axios.post(`${API_URL}/api/config/limpiar-tareas-pendientes`),

  limpiarCompletas: () =>
    axios.post(`${API_URL}/api/config/limpiar-completas`),

  // Generic methods
  get: (endpoint) =>
    axios.get(`${API_URL}${endpoint}`),

  post: (endpoint, data) =>
    axios.post(`${API_URL}${endpoint}`, data),

  // Email Templates
  getEmailTemplates: () =>
    axios.get(`${API_URL}/api/email-templates`),

  createEmailTemplate: (data) =>
    axios.post(`${API_URL}/api/email-templates`, data),

  updateEmailTemplate: (id, data) =>
    axios.put(`${API_URL}/api/email-templates/${id}`, data),

  deleteEmailTemplate: (id) =>
    axios.delete(`${API_URL}/api/email-templates/${id}`),

  setDefaultEmailTemplate: (id) =>
    axios.put(`${API_URL}/api/email-templates/${id}/default`),

  // Email Config
  getEmailConfig: () =>
    axios.get(`${API_URL}/api/email-config`),

  updateEmailConfig: (data) =>
    axios.put(`${API_URL}/api/email-config`, data),

  testEmailConfig: () =>
    axios.post(`${API_URL}/api/email-config/test`),

  // Email Send
  enviarEmailConsulta: (consultaId, templateId = null) =>
    axios.post(`${API_URL}/api/consultas/${consultaId}/enviar-email`, { template_id: templateId }),

  previewEmailConsulta: (consultaId, templateId = null) =>
    axios.post(`${API_URL}/api/consultas/${consultaId}/preview-email`, { template_id: templateId }),
};
